import { 
  AnalyticsDataQuery, 
  AnalyticsResponse, 
  IAnalyticsService, 
  AnalyticsConfig,
  FilterOption,
  HierarchyNode
} from '../types/analytics.types';

/**
 * Minimal placeholder service for edge cases where visualizations have no exampleResponse.
 * This should rarely be used since we prioritize configuration-based example data.
 */
export class PlaceholderAnalyticsService implements IAnalyticsService {
  async getConfig(configId: string): Promise<AnalyticsConfig> {
    throw new Error(`🔧 [PlaceholderAnalyticsService] Config management not supported. Config ID: ${configId}`);
  }

  async getConfigs(): Promise<AnalyticsConfig[]> {
    throw new Error(`🔧 [PlaceholderAnalyticsService] Config management not supported.`);
  }

  async processAnalytics(request: AnalyticsDataQuery): Promise<AnalyticsResponse> {
    console.warn(`🔧 [PlaceholderAnalyticsService] No example data found for visualization. Returning empty response.`);
    
    return {
      configId: request.configId || 'unknown',
      data: [],
      metadata: {
        totalRecords: 0,
        processingTime: 0,
        cacheHit: false,
        dataSource: 'placeholder',
        lastRefreshed: new Date()
      }
    };
  }

  async processTabAnalytics(configId: string, tabId: string, request: AnalyticsDataQuery): Promise<AnalyticsResponse> {
    console.warn(`🔧 [PlaceholderAnalyticsService] Tab analytics not supported. Returning empty response.`);
    
    return {
      configId,
      tabId,
      data: [],
      metadata: {
        totalRecords: 0,
        processingTime: 0,
        cacheHit: false,
        dataSource: 'placeholder',
        lastRefreshed: new Date()
      }
    };
  }

  async getFilterOptions(filterId: string, dependencies?: Record<string, any>): Promise<FilterOption[]> {
    console.warn(`🔧 [PlaceholderAnalyticsService] Filter options not supported. Filter ID: ${filterId}`);
    return [];
  }

  async expandHierarchyNode(configId: string, nodeId: string): Promise<HierarchyNode[]> {
    console.warn(`🔧 [PlaceholderAnalyticsService] Hierarchy expansion not supported. Returning empty array.`);
    return [];
  }

  async collapseHierarchyNode(configId: string, nodeId: string): Promise<void> {
    console.warn(`🔧 [PlaceholderAnalyticsService] Hierarchy collapse not supported.`);
  }
} 